// Typical set of fields that may be in a legacy data set.
export const SideLoadedDataSetTemplateColumns = [
  "Name",
  "ABN",
  "TradingName",
  "Email1",
  "Phone1",
  "FirstName1",
  "LastName1",
  "PIC1",
  "PIC2",
  "Address1",
  "Suburb",
  "State",
  "PostCode",
  "Brand",
  "AgentRef",
  "BSB",
  "AccountNumber",
  "AccountName",
  "Notes",
  "Labels",
];

export const SIDE_LOADED_DATA_SET_TEMPLATE_FILENAME =
  "legacy-data-template.csv";
